<template>
  <div class="grid-x servicios">
    <h3 class="cell servicios__title">CON DS PODRAS:</h3>
    <p class="cell servicios__subtitle"> Desde administrar torneos de fútbol, hasta tener un perfil como deportista </p>
    <div class="cell small-6 medium-3 large-2">
      <v-icon-text-card
        color="#e74c3c"
        icono="mdiLan"
        titulo="ORGANIZA TORNEOS"
        texto="Crea un torneo, apertura inscripciones, genera fixture, tabla de posiciones..."                                                                                                                                                                                                            
      />
    </div>
    <div class="cell small-6 medium-3 large-2">
      <v-icon-text-card
        color="#2980b9"
        icono="mdiShieldHalfFull"
        titulo="ADMINISTRA EQUIPOS"
        texto="Crear un equipo y participa en torneos, genera estadísticas, fichas de control ..."                                                                                                                                                                                                            
      />
    </div>
    <div class="cell small-6 medium-3 large-2">
      <v-icon-text-card
        color="#2ecc71"
        icono="mdiSealVariant"
        titulo="SE UNA LEYENDA"
        texto="Ten un perfil de futbolista, con tu historial de goles, asistencias, partidos"                                                                                                                                                                                                            
      />
    </div>
    <div class="cell small-6 medium-3 large-2">
      <v-icon-text-card
        color="#f39c12"
        icono="mdiAccountGroup"
        titulo="CIEF"
        texto="Se parte de nuestra comunidad internacional de embajadores del fútbol"                                                                                                                                                                                                            
      />
    </div>
  </div>
</template>

<script>

  import VIconTextCard from '@/components/base/VIconTextCard'

  import { mapGetters } from 'vuex'

  export default {
    name:'TheHomeServices',
    components: {
      VIconTextCard,
    },
    computed: {
    ...mapGetters({
      loadHome: 'loadHome',
      dataHome: 'dataHome'
    })
  },
  }
</script>

<style lang="scss" scoped>
  .servicios {
    padding: 10px;
    background: $color-8;
    justify-content: center;
    &__movie {
      height: 150px;
      margin-bottom: 1em;
      margin-top: 1em;
      @include desde ($medium) {
        height: 300px;
        width: 100%;
      }
      @include desde ($large) {
        width: 40%;
        height: 450px;
      }
    }
    @include desde($large) {
      padding: 2em;
    }
    &__title {
      font-family: $ff-1;
      font-size: 14px;
      text-align: center;
      @include desde($large) {
        font-size: 18px;
      }
    }
    &__subtitle {
      font-size: 12px;
      font-family: $ff-2;
      margin-bottom: 1em;
      text-align: center;
    }
  }
</style>